import styled from 'styled-components';

const ActivityEquityStyled = styled.div`
  .basic-title {
    font-size: 19px;
    font-family: SourceHanSansCN;
    font-weight: 500;
    color: #000000;
    padding: ${(props) => props.theme.spacing(7)} 0
      ${(props) => props.theme.spacing(4)};
  }
  .label-title {
    color: #000000;
  }
  .basic-cycle {
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    .label-require {
      color: #ff0000;
      font-size: 14px;
    }
  }

  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
  .all-level-wrap,
  .all-level-select {
    margin-top: ${(props) => props.theme.spacing(5)};
  }
  .different-level-select {
    margin-top: ${(props) => props.theme.spacing(29 / 8)};
  }
  .all-level-select,
  .different-level-select {
    margin-bottom: ${(props) => props.theme.spacing(7 / 2)};
    font-size: 16px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    line-height: 50px;
  }
  .level-title-wrap {
    width: 910px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 16px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    background: #f6f6f6;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-left: 24px;
  }
  .MuiButtonBase-root-MuiRadio-root.Mui-disable {
    color: grey;
  }
  .first-order-wrap {
    margin-top: ${(props) => props.theme.spacing(5)};
    .first-select-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      .first-order {
        color: #000000;
      }
    }
    .first-cycle {
      font-size: 14px;
      font-family: SourceHanSansCN;
      font-weight: 400;
      color: #000000;
      padding-bottom: ${(props) => props.theme.spacing(5)};
      /* flex:1; */
      width: 200px;
      .label-require {
        color: #ff0000;
        font-size: 14px;
      }
    }
  }
  .coupon,
  .noCoupon {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    margin-right: ${(props) => props.theme.spacing(0.5)};
  }
  .coupon {
    fill: #1565c0;
  }
  .noCoupon {
    fill: #c9c9c9;
  }
  .coupons {
    background: #1565c0;
  }
  .noCoupons {
    background: #666464;
  }
  .coupon-num {
    color: #1565c0;
  }
  .noCoupon-num {
    color: #c9c9c9;
  }

  .coupon-settings {
    width: 40px !important;
    height: 28px;
    border-radius: 4px;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    margin: auto;
    margin-left: ${(props) => props.theme.spacing(6 / 8)};
  }
  .coupons:hover {
    background-color: #1565c0 !important;
  }
  .noCoupons:hover {
    background-color: #c9c9c9 !important;
  }
  .MuiSvgIcon-root {
    color: ${(props) =>
      props.disabled
        ? props.theme.palette.secondary.disabled
        : props.theme.palette.primary.main};
  }
`;

export default ActivityEquityStyled;
